import * as React from 'react';
import { connect } from 'react-redux';
import './KPBreadcrumb.css';
import { REQUEST_DOCUMENTS, DONATE_MY_DECREASE, PERSONAL_INSURANCE } from '../../routes/routes';
import { navigateTo } from '../../actions/navigationActions';

class KPBreadcrumb extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.handleRedirect = this.handleRedirect.bind(this);
    }

    handleRedirect(destination) {
        if (!this.props.profile.isLinked && (
            destination === REQUEST_DOCUMENTS ||
            destination === DONATE_MY_DECREASE ||
            destination === PERSONAL_INSURANCE)) {
            // do nothing
        }
        else {
            this.props.redirectTo(destination);
        }
    }

    public render() {
        let breadCrumbDetails = [];
        breadCrumbDetails = this.props.navList.map((item) => {
            return <li className="breadcrumb-item" key={item.description}><button className="button-link" id={item.destination} onClick={() => this.handleRedirect(item.destination)}>{item.description}</button></li>
        });

        return (
            <>
                <div className="breadcrumb-size">
                    <ol className="breadcrumb">
                        {breadCrumbDetails}
                        <li className="breadcrumb-item active active-item">{this.props.activePage}</li>
                    </ol>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(KPBreadcrumb);